(function () {
  function init(root) {
    if (!root || root.dataset.taReady === 'true') return;
    root.dataset.taReady = 'true';

    function rotate(box, every) {
      if (!box) return;
      var slides = [].slice.call(box.children).filter(function (el) { return el.classList.contains('slide'); });
      var dots = box.querySelectorAll('.dots i');
      var i = 0;
      if (slides.length < 2) return;
      window.setInterval(function () {
        slides[i].classList.remove('on'); if (dots[i]) dots[i].classList.remove('on');
        i = (i + 1) % slides.length;
        slides[i].classList.add('on'); if (dots[i]) dots[i].classList.add('on');
      }, every);
    }
    rotate(root.querySelector('#ta-revcar'), 5000);
    rotate(root.querySelector('#ta-press'), 6000);

    var thumbs = root.querySelectorAll('#ta-thumbs .th');
    var main = root.querySelector('#ta-galmain');
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var key = t.getAttribute('data-slide');
        var slide = main.querySelector('.slide[data-slide="' + key + '"]');
        if (!slide) {
          slide = document.createElement('div');
          slide.className = 'slide';
          slide.setAttribute('data-slide', key);
          slide.innerHTML = t.innerHTML;
          var play = slide.querySelector('.tile.play[data-video]');
          if (play) {
            var v = document.createElement('video');
            v.src = play.getAttribute('data-video'); v.controls = true; v.playsInline = true; v.preload = 'metadata';
            var img = play.querySelector('img'); if (img) v.poster = img.currentSrc || img.src;
            play.innerHTML = ''; play.classList.remove('play'); play.classList.add('vid'); play.appendChild(v);
          }
          main.appendChild(slide);
        }
        main.querySelectorAll('.slide').forEach(function (x) { x.classList.remove('on'); });
        main.querySelectorAll('video').forEach(function (v) { v.pause(); });
        slide.classList.add('on');
      });
    });

    root.querySelectorAll('a[href="#ta-buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var buy = root.querySelector('#ta-buy'); if (!buy) return;
        e.preventDefault();
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var y = buy.getBoundingClientRect().top + window.pageYOffset - 24;
        window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    var currency = root.dataset.currency || 'USD';
    var locale = root.dataset.locale || 'en-US';
    function money(cents, trailing) {
      var whole = cents % 100 === 0;
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: (trailing || !whole) ? 2 : 0, maximumFractionDigits: 2 }).format(cents / 100);
    }
    var sw = root.querySelectorAll('#ta-sw i');
    var idInput = root.querySelector('#ta-variant');
    var price = root.querySelector('#ta-price');
    var submit = root.querySelector('.ta-atc');
    var submitText = submit && submit.querySelector('.single-add-to-cart-button--text');
    function choose(i) {
      sw.forEach(function (x) { x.classList.remove('on'); });
      i.classList.add('on');
      var cents = Number(i.getAttribute('data-price'));
      var available = i.getAttribute('data-available') === 'true';
      if (idInput) idInput.value = i.getAttribute('data-variant');
      if (price && cents) price.textContent = money(cents, true);
      if (submit) {
        submit.disabled = !available;
        submit.setAttribute('aria-disabled', String(!available));
        if (submitText) submitText.textContent = available ? (root.dataset.atcLabel + ' - ' + money(cents)) : root.dataset.soldOutLabel;
      }
    }
    sw.forEach(function (i) {
      i.addEventListener('click', function () { choose(i); });
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); choose(i); } });
    });
  }

  function boot() { document.querySelectorAll('#ta-page').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('#ta-page'); if (r) init(r); });
})();
